import { combineReducers, createStore } from "redux";
import { couponReducer } from "./Reducers/couponReducer";
import sessionReducer from "./Reducers/sessionReducer";
import { paginationReducer } from "./Reducers/paginationReducer";
import { eventTrackerReducer } from "./Reducers/eventTrackerReducer";
import { usbDeviceReducer } from "./Reducers/printingDeviceReducer";
import { labelPrinterDeviceReducer } from "./Reducers/labelPrinterDeviceReducer";
import { bluetoothDeviceReducer } from "./Reducers/bluetoothDeviceReducer";
import { serialReducer } from "./Reducers/weighingScaleReducer";
import { holdOrdersCountReducer } from "./Reducers/holdOrdersCountReducer";
import { denominationReducer } from "./Reducers/denominationReducer";

const rootReducer = combineReducers({
  coupon: couponReducer,
  session: sessionReducer,
  pagination: paginationReducer,
  eventTime: eventTrackerReducer,
  printing: usbDeviceReducer,
  labelPrinting: labelPrinterDeviceReducer,
  bluetoothPrinting:bluetoothDeviceReducer,
  weighingScale:serialReducer,
  holdOrdersCount:holdOrdersCountReducer,
  denominations: denominationReducer,
});

export const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
